/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaistartfallbackunreadable4Inputs */

const en_eventaistartfallbackunreadable4 = /** @type {(inputs: Eventaistartfallbackunreadable4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The page behind the link could not be read. We kept the link, please fill in the rest yourself.`)
};

const de_eventaistartfallbackunreadable4 = /** @type {(inputs: Eventaistartfallbackunreadable4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Seite hinter dem Link ließ sich nicht lesen. Den Link haben wir übernommen, bitte füll den Rest selbst aus.`)
};

/**
* | output |
* | --- |
* | "The page behind the link could not be read. We kept the link, please fill in the rest yourself." |
*
* @param {Eventaistartfallbackunreadable4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartfallbackunreadable4 = /** @type {((inputs?: Eventaistartfallbackunreadable4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartfallbackunreadable4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartfallbackunreadable4(inputs)
	return de_eventaistartfallbackunreadable4(inputs)
});
export { eventaistartfallbackunreadable4 as "eventAiStartFallbackUnreadable" }